import FormattedMessage from 'I18n/components/FormattedMessage';
import { H2 } from 'foundations-components/transitional/components/H2';
import { Button } from 'foundations-components/transitional/components/Button';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AiEditsConfirmModal = ({
  onConfirm,
  onDismiss
}) => {
  return /*#__PURE__*/_jsxs(Modal, {
    use: "info",
    width: 480,
    centered: true,
    children: [/*#__PURE__*/_jsxs(DialogHeader, {
      children: [/*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: onDismiss
      }), /*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "aiEditsPolling.confirmModal.header"
        })
      })]
    }), /*#__PURE__*/_jsx(DialogBody, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "aiEditsPolling.confirmModal.body"
      })
    }), /*#__PURE__*/_jsxs(DialogFooter, {
      align: "center",
      children: [/*#__PURE__*/_jsx(Button, {
        onClick: onConfirm,
        use: "primary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "aiEditsPolling.confirmModal.confirmLabel"
        })
      }), /*#__PURE__*/_jsx(Button, {
        onClick: onDismiss,
        use: "secondary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "aiEditsPolling.confirmModal.dismissLabel"
        })
      })]
    })]
  });
};
export default AiEditsConfirmModal;